import { render } from "./CategoryEdit.vue?vue&type=template&id=a5ed01d4&ts=true"
import script from "./CategoryEdit.vue?vue&type=script&lang=ts"
export * from "./CategoryEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__